// extracted by mini-css-extract-plugin
export default {"checkboxButtonLabel":"checkBoxButton_checkboxButtonLabel__KJ7gI","buttonText":"checkBoxButton_buttonText__yGPZ2"};